import Controller from "./listObjects.controller";
import template from "./listObjects.html";

const listObjects = {
  template,
  controller: Controller,
  bindings: {
    selected: "<",
    items: "=",
    typeList: "<",
    resource: "@",
    title: "@",
    name: "@",
    eventName: "<",
    sortable: "@",
    permissionName: "@",
    updateEvent: "&",
    editable: "<",
  },
};

export default listObjects;



// WEBPACK FOOTER //
// ./src/components/listObjects/listObjects.component.js